<template>

  <Form
    :title="$t('Account slug')"
    :creating="creating"
    :loading="loading">
    <form
      id="profile-form"
      class="shurt-conatiner"
      v-on:submit.prevent="saveProfile(account)">
      <div class="form-group">
        <label>{{ $t('Slug') }}</label>
        <input
          v-autofocus
          type="text"
          class="form-control"
          v-model="account.slug">
        <ValidateMessage :error="validateErrors['slug']" />
      </div>
      <div class="my-2 alert alert-warning">Ao alterar o "slug" de sua conta, links de vagas previamente compartilhados em plataformas como o LinkedIn e links inseridos em mensagens de e-mails podem se tornar inválidos, levando a páginas de erro. Recomendamos precaução ao realizar essa ação.</div>
    </form>
    <template slot="actions">
      <button
        type="submit"
        form="profile-form"
        class="btn btn-primary">
        {{ $t('Save') }}
        </button>
      <router-link
        to="/config/account"
        class="btn btn-secondary">{{ $t('Cancel') }}</router-link>
    </template>
  </Form>

</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'AccountSlug',
  components: {
    Form
  },
  data () {
    const account = this.$store.getters.getAccount
    const {
      _id,
      slug
    } = account

    return {
      creating: false,
      loading: false,
      account: {
        _id,
        slug
      },
      validateErrors: false
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    /*
    saveProfile
    */
    saveProfile (data) {
      this.loading = true

      this.$store
      .dispatch('updateAccountSlug', {
        _id: this.account._id,
        slug: this.account.slug
      })
      .then((result) => {
        this.$router.push('/config/account')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Account/AccountSlug.vue